<template>

  <modal name="dayInfoModal" @closed="hideModal" tabindex="-1" aria-hidden="true" width="737" height="auto" style="overflow-y: scroll;">
    <div class="p-5">
      <div class="row">
        <div class="col-8">
          <h1 class="mb-2">{{ selected_date | moment("Do") }} {{ selected_date | moment("MMMM") }}</h1>
          <h2>
            <span class="text-muted">for {{getMember(selected_account_id).first_name}} {{getMember(selected_account_id).last_name}}</span>
          </h2>
        </div>
        <div class="col-2">
          <time-circle-element
            :time="duration_tasks_list.reduce((a, b) => a + (b.duration || 0) - (b.duration_actual || 0), 0) || 0"
            color="#3780DF"></time-circle-element>
        </div>
        <div class="col-2">
          <time-circle-element
            :time="duration_actual_list.reduce((a, b) => a + b.value, 0)"
            color="#35A666" />
        </div>
      </div>
      <div class="mt-5" v-if="duration_actual_list">
        <template v-for="(actual_log, index) in duration_actual_list">
          <div :key="'actual_log' + index" class="row">
            <div class="col-2 text-center border-right border-primary p-1 text-muted pt-2 pb-6">
              {{actual_log.created_at | moment('HH:MM')}}
            </div>
            <div class="col-10 p-2">
              <svg class="leftEllipse" width="30" height="20" viewBox="0 0 30 20" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="9.25" fill="white" stroke="#35A666" stroke-width="1.5"/>
                <circle cx="10" cy="10" r="3" fill="#35A666"/>
                <path d="M20 10L29 10" stroke="#35A666" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <div class="row pl-5">
                <div class="col-4 timeBox">
                  <span class="font-weight-bold text-primary">
                    {{stringifyDuration(actual_log.value)}}
                  </span>
                  <span @click="deleteDurationActualLogs(actual_log._id)" class="text-muted trashUnderBox">
                    <i class="fe fe-trash-2"></i>
                  </span>
                  <span class="text-muted userUnderBox">
                    by {{ getMember(actual_log.created_by).first_name }} {{ getMember(actual_log.created_by).last_name }}
                  </span>
                </div>
                <div class="col-10 ml-3 p-2 list-group-item bg-light">
                  <task-view
                    :task="getTask(actual_log.task_id)"
                    :epic-links="epic_links"
                    :members="members"
                    :projects="projects"
                    :sections="sections"
                    view="calendar_day_info"
                  ></task-view>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!--<div class="col-md-12">
          <div v-for="actual_log in duration_actual_list" class="card shadow-sm p-3 mb-4">
            <div class="row">
              <div class="col-4 text-center">
                <span class="small " style="font-size: 0.9rem"><code><span class="font-weight-bold text-primary">
                  {{stringifyDuration(actual_log.value)}}</span></code><br> logged by {{getMember(actual_log.created_by).first_name}}<br> at <i>{{actual_log.created_at | moment('HH:MM')}}</i>
                </span>
              </div>
              <div class="col-8">
                <div class="position-relative pt-0 pl-3 pr-3 " style="font-size: 0.66rem">
                  <task-view :task="getTask(actual_log.task_id)" view="calendar_day_info"></task-view>
                </div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </modal>
</template>

<script>
  import TaskView from '../components/elements/TaskView';
  import TimeCircleElement from '../components/base/elements/TimeCircle.element';
  import { mapGetters } from 'vuex';
  import { stringifyDurationMixin } from '@/mixins/stringifyDurationMixin';

  const moment = require('moment');

  export default {
    name: 'day_info_modal',
    mixins: [stringifyDurationMixin],
    data () {
      return {
        duration_tasks_list: [],
        duration_actual_list: [],
      };
    },
    computed: {
      ...mapGetters([
        'show_modal_day_info',
        'tasks',
        'duration_actual_logs',
        'selected_date',
        'selected_account_id',
        'members',
        'epic_links',
        'projects',
        'sections',
      ]),
    },
    filters: {
      moment: function (date, format) {
        return moment(date).format(format);
      },
    },
    watch: {
      show_modal_day_info: function () {
        if (this.show_modal_day_info) {
          this.$modal.show('dayInfoModal');
          this.calculateData();
        }
      },
      duration_actual_logs: function () {
        this.calculateData();
      },
    },
    methods: {
      calculateData () {
        this.duration_tasks_list = this.tasks.filter(task => task.plan_date === this.selected_date && task.assignee === this.selected_account_id);
        this.duration_actual_list = this.duration_actual_logs.filter(log => log.date === this.selected_date && log.person === this.selected_account_id);
      },

      getMember (memberId) {
        return this.members.find(m => m._id === memberId, 1) || {};
      },

      getTask (taskId) {
        return this.tasks.find(m => m._id === taskId, 1) || {};
      },
      deleteDurationActualLogs (logId) {
        this.$api().post(`/projects/duration_actual_logs/${logId}/delete`, {}, {
          params: {
            token: localStorage.getItem('token'),
          },
        });
      },
      hideModal () {
        this.$store.commit('hideModal', 'day_info');
        this.$modal.hide('dayInfoModal');
      },
    },
    components: {
      TaskView,
      TimeCircleElement,
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  html, body {
    width: 100%;
    height: 100%;
  }

  .leftEllipse {
    position: absolute;
    left: -10px;
    top: 8px;
  }

  .timeBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    flex: 0 0 67px;
    border: 2px solid #DDE5F0;
    border-radius: 6px;
    height: 67px;
  }

  .timeBox span {
    vertical-align: center;
  }

  .userUnderBox {
    transition-duration: .5s;
    opacity: 0;
    position: absolute;
    left: -2px;
    top: 68px;
    font-size: 10px;
    width: 120%;
  }

  .trashUnderBox {
    cursor: pointer;
    transition-duration: .5s;
    opacity: 0;
    position: absolute;
    right: -10px;
    top: -10px;
    font-size: 10px;
    padding-top: 3px;
    border-radius: 50%;
    width: 21px;
    height: 21px;
    text-align: center;
    background-color: #E43A5A;
  }

  .trashUnderBox i {
    color: white;
  }

  .timeBox:hover .trashUnderBox, .timeBox:hover .userUnderBox {
    transition-duration: .5s;
    opacity: 1;
  }

  .list-group-item {
    border-radius: 7.5px;
  }
</style>
